import { Component, Input, OnInit } from '@angular/core';
import { PaymentService, PaymentV2Service, UtilService, VariablesService, VwoService } from '../../shared/services';

@Component({
  selector: 'app-quicdonate_carousel',
  templateUrl: './quicdonate_carousel.component.html',
  styleUrls: ['./quicdonate_carousel.component.scss']
})
export class QuickDonateCarouselComponent implements OnInit {
  @Input() currency = 'INR';
  isMobile: any;
  isIos;

  user;
  lastPaymentmode = [];

  constructor(
    public vars: VariablesService,
    public vwo: VwoService,
    public utilService: UtilService,
    public paymentService: PaymentService,
    public paymentV2: PaymentV2Service
  ) { }

  ngOnInit(): void {
    this.isMobile = this.utilService.isMobile();
    this.isIos = this.utilService.isIOSDevice();

    this.vars.userData.subscribe(res => {
      this.user = res;
      if (this.user) {
        this.getPaymentOptionsforQD(this.currency);
      }
    })
  }

  getPaymentOptionsforQD(currency) {
    let params = `&mobile_no=${this.user?.phone_1}&is_mobile=${this.utilService.isMobile() ? 1 : 0}&amount=${this.user?.lastorder?.donated_amount_local}`;
    this.paymentService.getPaymentOptions(currency, params).subscribe((res: any) => {
      if (res?.data?.options?.PREVPAYGATEWAYRECOMM) {
        Object.keys(res?.data?.options?.PREVPAYGATEWAYRECOMM).sort().reverse().slice(0,3).forEach((k,j) => {
          if (!(res?.data?.options?.PREVPAYGATEWAYRECOMM[k].payment_mode === 'UPI' && res?.data?.options?.PREVPAYGATEWAYRECOMM[k].payment_mode_value !== 'VPA' && (this.isIos || !this.isMobile))) {
            this.lastPaymentmode.push(res?.data?.options?.PREVPAYGATEWAYRECOMM[k])
            if (this.lastPaymentmode[j]?.checksum?.name) {
              const arr = res?.data?.options?.PREVPAYGATEWAYRECOMM[k]?.checksum?.name.toLowerCase().split(" ");
              for (var i = 0; i < arr.length; i++) {
                arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
              }
              this.lastPaymentmode[j].checksum.name = arr.join(" ")
            }
          }
        });
      }
      else {
        this.lastPaymentmode = null;
      }
    });
  }

  donate(i) {
    this.vars.otdpayment.next({'paymode' : this.lastPaymentmode[i], 'amount': this.lastPaymentmode[i].amount})
  }
}
